import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { Provider } from 'react-redux';
import store from './state/store'
import Theme from "./theme";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

class App extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Router>
            <Theme />
          </Router>
        </QueryClientProvider>
      </Provider>
    )
  }
}


export default App;